function getWishlistKey() {
  return window.taeluxCustomerId
    ? 'taeluxWishlist_' + window.taeluxCustomerId
    : 'taeluxWishlist_guest';
}

function getWishlist() {
  return JSON.parse(localStorage.getItem(getWishlistKey())) || [];
}

function saveWishlist(wishlist) {
  localStorage.setItem(getWishlistKey(), JSON.stringify(wishlist));
}

function refreshWishlistCount() {
  const wishlist = getWishlist();
  const counter = document.getElementById('wishlist-count');

  if (!counter) return;

  counter.textContent = wishlist.length;

  if (wishlist.length > 0) {
    counter.style.display = 'flex';
    counter.classList.remove('wishlist-hidden');
  } else {
    counter.style.display = 'none';
    counter.classList.add('wishlist-hidden');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const container = document.getElementById('wishlist-products');

  if (!container) return;

  function renderWishlist() {
    let wishlist = getWishlist();

    wishlist = wishlist.filter(product =>
      product &&
      product.handle &&
      product.title &&
      product.url &&
      product.image &&
      product.price
    );

    saveWishlist(wishlist);

    if (wishlist.length === 0) {
      container.innerHTML = '<p class="wishlist-empty">Vous n’avez aucun produit dans vos favoris.</p>';
      refreshWishlistCount();
      return;
    }

    let html = '<div class="wishlist-grid">';

    wishlist.forEach(product => {
      html += `
        <div class="wishlist-item">
          <button
            class="taelux-wishlist-btn active"
            type="button"
            data-handle="${product.handle}">
            <span class="wishlist-icon">♥</span>
          </button>

          <a href="${product.url}" class="wishlist-image-link">
            <img src="${product.image}" alt="${product.title}" class="wishlist-image">
          </a>

          <div class="wishlist-info">
            <a href="${product.url}" class="wishlist-title">${product.title}</a>
            <p class="wishlist-price">${product.price}</p>

            <button
              type="button"
              class="wishlist-button add-to-cart-btn"
              data-handle="${product.handle}">
              Ajouter au panier
            </button>
          </div>
        </div>
      `;
    });

    html += '</div>';
    container.innerHTML = html;

    refreshWishlistCount();
  }

  renderWishlist();

  document.addEventListener('click', async function (e) {
    const removeBtn = e.target.closest('.wishlist-item .taelux-wishlist-btn');

    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();

      const handle = removeBtn.dataset.handle;

      let wishlist = getWishlist();
      wishlist = wishlist.filter(item => item.handle !== handle);

      saveWishlist(wishlist);

      renderWishlist();
      refreshWishlistCount();

      return;
    }

    const cartBtn = e.target.closest('.add-to-cart-btn');

    if (!cartBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = cartBtn.dataset.handle;

    try {
      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();
      const variantId = product.variants[0].id;

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      window.location.href = '/cart';

    } catch (error) {
      console.error('Erreur ajout panier:', error);
    }
  });
});